module.exports = __webpack_public_path__ + "img/map-jp.a68e7cf3.jpg";